export default __webpack_public_path__ + "static/AI-01 1-4898f2508adaf9a55601f97b1648f0a3.png";